import Vue from "vue";
import VueRouter from "vue-router";
import Vuex from "vuex";
Vue.use(Vuex);
import SiteLayout from "@/views/layout/SiteLayout";

// Site Views ==> Lazy lodading components
const HomeView = () => import("@/views/site/HomeView");

const ContentView = () => import("@/views/site/products/ContentView");
const ClouddesignView = () => import("@/views/site/products/ClouddesignView");
const ModalviewerView = () => import("@/views/site/products/ModalviewerView");
const VirtualshowroomView = () =>
  import("@/views/site/products/VirtualshowroomView");
const PhotostudioView = () => import("@/views/site/products/PhotostudioView");
const ProfessionalsView = () =>
  import("@/views/site/solutions/ProfessionalsView");
const BrandsView = () => import("@/views/site/solutions/BrandsView");
const RealestateView = () => import("@/views/site/solutions/RealestateView");
const InspirationView = () =>
  import("@/views/site/inspiration/InspirationView");
const SubscriptionsView = () => import("@/views/site/SubscriptionsView");
const CookiePolicy = () => import("@/views/site/footer/CookiePolicy");
const UserAgreement = () => import("@/views/site/footer/UserAgreement");
const PrivacyPolicy = () => import("@/views/site/footer/PrivacyPolicy");
const PropertyTerms = () => import("@/views/site/footer/PropertyTerms");
const RefundPolicy = () => import("@/views/site/footer/RefundPolicy");
const ReturnAndShippingPolicy = () =>
  import("@/views/site/footer/ReturnAndShippingPolicy");
const ForgotpasswordView = () => import("@/views/site/ForgotpasswordView");
const ResetPassword = () => import("@/views/site/ResetPassword");
const ScheduleDemo = () => import("@/views/site/ScheduleDemo");
const AboutView = () => import("@/views/site/footer/AboutView");
const SignupView = () => import("@/views/site/SignupView");
const LoginView = () => import("@/views/site/LoginView");
const LogoutView = () => import("@/views/site/LogoutView");

const CheckoutPage = () => import("@/views/site/SubscriptionCheckout");

Vue.use(VueRouter);
var routes;
let userData = JSON.parse(localStorage.getItem("userData"));
var siteRoutesArray = [
  //Routes for sites
  { path: "", component: HomeView, name: "Home", meta: { title: "Home" } },
  {
    path: "/content",
    component: ContentView,
    name: "Content Creation",
    meta: { title: "Content Creation" },
  },
  {
    path: "/cloud-design",
    component: ClouddesignView,
    name: "3d Cloud Design",
    meta: { title: "3d Cloud Design" },
  },
  {
    path: "/3d-model",
    component: ModalviewerView,
    name: "3D Modal Viewer",
    meta: { title: "3D Model Viewer" },
  },
  {
    path: "/virtual",
    component: VirtualshowroomView,
    name: "Virtual Showroom",
    meta: { title: "Virtual Showroom" },
  },
  {
    path: "/studio",
    component: PhotostudioView,
    name: "Photo & Video Studio",
    meta: { title: "Photo & Video Studio" },
  },
  {
    path: "/professionals",
    component: ProfessionalsView,
    name: "Professionals",
    meta: { title: "Professionals" },
  },
  {
    path: "/brands",
    component: BrandsView,
    name: "Brands",
    meta: { title: "Brands" },
  },
  {
    path: "/estate",
    component: RealestateView,
    name: "Real Estate",
    meta: { title: "Real Estate" },
  },
  {
    path: "/inspiration",
    component: InspirationView,
    name: "InspirationView",
    meta: { title: "Inspiration" },
  },
  {
    path: "/subscription",
    component: SubscriptionsView,
    name: "SubscriptionsView",
    meta: { title: "Subscriptions" },
  },
  // CheckoutPage
  {
    path: "/checkout",
    component: CheckoutPage,
    name: "CheckoutPage",
    meta: { title: "CheckoutPage" },
  },
  {
    path: "/forgot",
    component: ForgotpasswordView,
    name: "forgotpassword",
    meta: { title: "forgotpassword" },
  },
  {
    path: "password_reset/*",
    component: ResetPassword,
    name: "Contact",
    meta: { title: "Reset Password" },
  },
  {
    path: "/cookie-policy",
    component: CookiePolicy,
    name: "CookiePolicy",
    meta: { title: "Cookie Policy" },
  },
  {
    path: "/user-agreement",
    component: UserAgreement,
    name: "UserAgreement",
    meta: { title: "User Agreement" },
  },
  {
    path: "/privacy-policy",
    component: PrivacyPolicy,
    name: "PriacyPolicy",
    meta: { title: "Privacy Policy" },
  },
  {
    path: "/refund-policy",
    component: RefundPolicy,
    name: "RefundPolicy",
    meta: { title: "Refund Policy" },
  },
  {
    path: "/return-shipping-policy",
    component: ReturnAndShippingPolicy,
    name: "ReturnAndShippingPolicy",
    meta: { title: "Return And Shipping Policy" },
  },
  {
    path: "/terms",
    component: PropertyTerms,
    name: "PropertyTerms",
    meta: { title: "Intellectual Property Terms" },
  },
  {
    path: "/demo",
    component: ScheduleDemo,
    name: "ScheduleDemo",
    meta: { title: "Schedule Demo" },
  },
  {
    path: "/about",
    component: AboutView,
    name: "AboutView",
    meta: { title: "About Us" },
  },
  {
    path: "/site/signup",
    component: SignupView,
    name: "SignupView",
    meta: { title: "Sign Up" },
  },
  {
    path: "/site",
    component: LoginView,
    name: "LoginView",
    meta: { title: "Login" },
  },
  {
    path: "/logout",
    component: LogoutView,
    name: "LogoutView",
    meta: { title: "Logout" },
  },
];

routes = [
  {
    path: "/",
    component: SiteLayout,
    children: siteRoutesArray,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.PUBLIC_PATH,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return $("html,body")
        .stop()
        .animate({ scrollTop: $(to.hash).offset().top }, 1000);
    } else {
      return $("html,body")
        .stop()
        .animate({ scrollTop: 0 }, 500);
    }
  },
});

export default router;
